import { ListGroup, GroupHeader } from "./list-types";
import { assert, panic } from "common/Support";

export function isGroupHeader<T>(item: T | GroupHeader): item is GroupHeader {
    return (item as any).isGroupHeader === true;
}

export class ListProxy<T> {
    constructor(private items: readonly T[] | undefined, private groups: readonly ListGroup<T>[] | undefined) {
        assert(this.groups !== undefined || this.items !== undefined);
    }

    public get(index: number): T | GroupHeader {
        if (this.items !== undefined) {
            return this.items[index];
        }

        assert(this.groups !== undefined);

        for (const g of this.groups) {
            if (index === 0) {
                return {
                    isGroupHeader: true,
                    groupHeaderName: g.title,
                    onSeeAll: g.onSeeAll,
                };
            }
            index--;

            if (index < g.items.length) {
                return g.items[index];
            }

            index -= g.items.length;
        }

        panic("Groups or Items must be valid.");
    }

    public get length(): number {
        if (this.items !== undefined) {
            return this.items.length;
        }

        assert(this.groups !== undefined);

        return this.groups.map(g => g.items.length + 1).reduce((pv, cv) => pv + cv, 0);
    }
}
